<div class="container-fliud">

  <!-- Patreon Card Here -->
  <div *ngIf="showFooter" class="">

    <div class="">
      <div class="patreon-card" style="border: none; background-color: #ffebda;">
        <div class="row no-gutters cl_animation1">

          <div class="col-md-8" style="text-align: center;">
            <div class="card-body ">
              <h5 class="card-title patreon_head">Want Early Build access ?</h5>
              <p class="pat-card-sum">Join us on patreon for
                exclusivity.
                Choose the tier that suits your requirement and it starts from 3$ </p>
              <br>

              <div>
                <footer class="blockquote-footer"> Exclusive build & features that aren't available for public
                </footer>
                <footer class="blockquote-footer"> Get latest bugfixes and active development builds
                </footer>
                <footer class="blockquote-footer"> Early Build access with source update</footer>
                <footer class="blockquote-footer"> Sponsor & VIP Tag in our Website</footer>
                <footer class="blockquote-footer"> Personal Build with Requested Feature</footer>
                <footer class="blockquote-footer"> If needed then private chat support for builds related
                  issues</footer>
                <footer class="blockquote-footer"> Access to full source</footer>
                <footer class="blockquote-footer"> Exclusive voting power</footer>
                <footer class="blockquote-footer"> Full Guidance and Support from TEAM</footer>
              </div>
              <br>

            </div>
          </div>

          <div class="col-md-4 patreon-card-right">

            <img src="./assets/images/patreon.png" class="card-img patreon_new-cl" alt="img">

            <a target="_blank" href="https://www.patreon.com/join/uglykid24">
              <p> <a class="btn shadow patreon-btn" style="display: inline-block;">
                  <svg width="22" height="22" viewBox="0 -4.5 256 256" version="1.1" class="bi bi-patreon"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    preserveAspectRatio="xMidYMid">
                    <g>
                      <path
                        d="M45.1355837,0 L45.1355837,246.35001 L0,246.35001 L0,0 L45.1355837,0 Z M163.657111,0 C214.65668,0 256,41.3433196 256,92.3428889 C256,143.342458 214.65668,184.685778 163.657111,184.685778 C112.657542,184.685778 71.3142222,143.342458 71.3142222,92.3428889 C71.3142222,41.3433196 112.657542,0 163.657111,0 Z"
                        fill="#ffffff"></path>
                    </g>
                  </svg> Join us on Patreon
                </a>
              </p>
            </a>

            <a target="_blank" href="https://www.buymeacoffee.com/Uglykid">
              <p> <a class="btn shadow patreon-btn" style="display: inline-block; letter-spacing: 2px;">
                  <svg fill="#ffffff" width="26" height="26" class="bi bi-patreon" viewBox="0 0 24 24" role="img"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m20.216 6.415-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 0 1 3.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 0 1-4.743.295 37.059 37.059 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0 0 11.343.376.483.483 0 0 1 .535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613z" />
                  </svg> Buy Me a Coffee
                </a>
              </p>
            </a>
          </div>

        </div>
      </div>
    </div>

  </div>

  <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
  </ng2-adsense>

  <br>

  <div *ngIf="showFooter">
    <h1 class="cl-head cl_animation1"> Checkout the latest <strong class="key-high">changes</strong> of Android 15 シ
    </h1>
  </div>

  <br>

  <!-- Android 15 Changelog card here -->
  <div class="high-card website_animation container rounded shadow-light" style="background-color: white;">
    <div class="row">

      <div class="col-md-6">
        <div class="card-body">
          <h5 class="card-title a14cl_head" style="font-family: monospace ">Elixir <strong
              style="color: #e77d5a;">5.5</strong> : Exceeds expectations consistently</h5>
          <div style="text-align: left;">
            <footer class="blockquote-footer"> Introducing Project Elixir now based on Android 15 シ</footer>
            <footer class="blockquote-footer"> Merged latest Security patch from Google</footer>
            <footer class="blockquote-footer"> CTS and play integrity passes and banking apps are working fine </footer>
            <footer class="blockquote-footer"> Exclusive : Added Revamped Automated depth clocks </footer>
            <footer class="blockquote-footer"> Exclusive : Automatic depth clock: No need to set subject separately
            </footer>
            <footer class="blockquote-footer"> Exclusive : Re-Designed Whole UI adapt for Android 15</footer>
            <footer class="blockquote-footer"> Exclusive: Essence: Add randomization support for udfps animation
            </footer>
            <footer class="blockquote-footer"> Exclusive : Added few more depth clock styling like HyperOS [wip]
            </footer>
            <footer class="blockquote-footer"> Added our own launcher aka BREW launcher </footer>
            <footer class="blockquote-footer"> Added Re-Designed Volume Panel </footer>
            <footer class="blockquote-footer"> Circle to search works by default </footer>
            <footer class="blockquote-footer"> Added support for LMOFreeform service </footer>
            <footer class="blockquote-footer"> Essence: Added Battery style options </footer>
            <footer class="blockquote-footer"> Added App lock and face unlock</footer>
            <footer class="blockquote-footer"> Essence: Added advanced monet customization</footer>
            <footer class="blockquote-footer"> Essence: Added status bar customisations </footer>
            <footer class="blockquote-footer"> Added a lot of basic options for statusbar, qs, lockscreen</footer>
            <footer class="blockquote-footer"> Added theming section for icon, font, slider, etc</footer>
            <footer class="blockquote-footer"> Added Re-Designed Seekbar </footer>
            <footer class="blockquote-footer"> Added a hell lot of stuff checkout full changelog</footer>
            <footer class="blockquote-footer"> Much More, Try by yourself</footer>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <img src="./assets/images/chrstms-download.png" class="a15changelog-img" style="mix-blend-mode: multiply;"
          alt="img">

        <a href="https://www.patreon.com/posts/introducing-now-120739925">
          <p><a class="btn shadow cl-btn ">Changelog on Patreon/BMC</a></p>
        </a>
      </div>
    </div>
  </div>

  <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
  </ng2-adsense>

  <div *ngIf="showFooter">

    <!-- Android 14 Changelog card here -->

    <h1 class="cl-head website_animation"> Checkout the last <strong class="key-high">changes</strong> of Android 14
    </h1>

    <div class="high-card container rounded shadow-light website_animation" style="background-color: white;">
      <div class="row">

        <div class="col-md-8">
          <div class="card-body card-body-changelog">
            <h5 class="card-title c_head " style="font-family: monospace;">Elixir <strong
                style="color: #e77d5a;">4.8</strong> : Android 14 </h5>
            <div style="text-align: left;">
              <footer class="blockquote-footer"> Merged latest January 2025 Security patch </footer>
              <footer class="blockquote-footer"> CTS and play integrity passes and banking apps are working fine
              </footer>
              <footer class="blockquote-footer"> Exclusive : Automated auto depth clocks updated</footer>
              <footer class="blockquote-footer"> Exclusive : Re-Designed Whole UI</footer>
              <footer class="blockquote-footer"> Added App lock and face unlock back</footer>
              <footer class="blockquote-footer"> Exclusive : Revamped the whole depth clock options</footer>
              <footer class="blockquote-footer"> Added a ton of Battery style options </footer>
              <footer class="blockquote-footer"> You can set any depth wallpaper you want, no need to set subject
              </footer>
              <footer class="blockquote-footer"> Allow setting quick QS Custs </footer>
              <footer class="blockquote-footer"> Essence: A11 QS UI Style </footer>
              <footer class="blockquote-footer"> Essence: Add QS Panel Style </footer>
              <footer class="blockquote-footer"> Essence: QuickSettings: Add QS Header Image customization </footer>
              <footer class="blockquote-footer"> Essence: Switch to intensity based volume haptic</footer>
              <footer class="blockquote-footer"> themes: Implement Volume Styles </footer>
              <footer class="blockquote-footer"> Essence: Add some more automated depth clock styles</footer>
              <footer class="blockquote-footer"> colors: Introduce Reality display engine </footer>
              <footer class="blockquote-footer"> SystemUI: Redesign Volume Panel the 404 way </footer>
              <footer class="blockquote-footer"> Redesign seekbar </footer>
              <footer class="blockquote-footer"> Added a hell lot of stuff checkout full changelog</footer>
              <footer class="blockquote-footer"> Much More, Try by yourself</footer>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <img src="./assets/images/A14_cl.jpg" style="mix-blend-mode: darken; margin-top: 3.5rem; width: 18rem;"
            alt="img">

          <a
            href="https://github.com/ProjectElixir-Devices/Changelogs/tree/vany?tab=readme-ov-file#--below-changes-are-from-android-14-">
            <p><a class="btn shadow cl-btn ">All android 14 changelogs</a></p>
          </a>
        </div>
      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Android 13 Changelog card here -->
    <h1 class="cl-head cl_animation1"> Checkout the last <strong class="key-high">changes</strong> of Android 13
    </h1>

    <div class="container shadow-light round cl_animation1">
      <div class="card mb-3 changelog_card">
        <div class="row no-gutters">

          <div class="col-md-8">
            <div class="card-body card-body-changelog">
              <h5 class="card-title c_head " style="font-family: monospace;">Elixir <strong
                  style="color: #e77d5a;">3.13</strong> : Android 13 </h5>
              <footer class="blockquote-footer"> CTS Passes by default and banking apps are working fine</footer>
              <footer class="blockquote-footer"> Exclusive: Added 2 new lock screen clock</footer>
              <footer class="blockquote-footer"> Exclusive: Added all new 25 iOS style depth clock</footer>
              <footer class="blockquote-footer"> Added greeting in homepage of settings</footer>
              <footer class="blockquote-footer"> Settings: Add card layout to System</footer>
              <footer class="blockquote-footer"> Revamped Settings dashboard UI </footer>
              <footer class="blockquote-footer"> Added QS Header img preview</footer>
              <footer class="blockquote-footer"> Switched Gapps to minimal one and cleanup</footer>
              <footer class="blockquote-footer"> Fixed Status bar traffic indicator crashes when set to set
                auto-hide</footer>
              <footer class="blockquote-footer"> Merged translations from crowdin</footer>
              <footer class="blockquote-footer"> Re arranged and adapted UI with proper category</footer>
              <footer class="blockquote-footer"> Fixed some issues with updater UI </footer>
              <footer class="blockquote-footer"> Fix the shrinked battery graph </footer>
              <footer class="blockquote-footer"> SystemUI: Integrate Google Lens into Screenshot UI </footer>
              <footer class="blockquote-footer"> Fixed many bugs related to battery backup, heating and ui glitch
              </footer>
              <footer class="blockquote-footer"> Improved stability and performance</footer>
              <footer class="blockquote-footer"> Much More, Try by yourself</footer>

            </div>
          </div>

          <div class="col-md-4">
            <img src="./assets/images/A13_cl.webp" class="card-img cl_img" alt="img">

            <a
              href="https://github.com/ProjectElixir-Devices/Changelogs/tree/tiramisu#--below-changes-are-from-android-13-">
              <p><a class="btn shadow cl-btn ">All android 13 changelogs</a></p>
            </a>

          </div>
        </div>
      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Android 12 Changelog card here -->
    <h1 class="cl-head cl_animation1"> Checkout the last <strong class="key-high">changes</strong> of Android 12
    </h1>

    <div class="container shadow-light round cl_animation1">
      <div class="card mb-3 changelog_card">
        <div class="row no-gutters">

          <div class="col-md-8">
            <div class="card-body card-body-changelog">
              <h5 class="card-title c_head " style="font-family: monospace;">Elixir <strong
                  style="color: #e77d5a;">2.11</strong> : Android 12 </h5>
              <footer class="blockquote-footer"> Merged latest August Security patch </footer>
              <footer class="blockquote-footer"> CTS passes by default and banking apps are working fine</footer>
              <footer class="blockquote-footer"> Settings: Elixir: Redesign My Device Page </footer>
              <footer class="blockquote-footer"> Settings: Elixir : Redesign our Firmware information</footer>
              <footer class="blockquote-footer"> Settings: Elixir: Adapt our new layout in rest settings </footer>
              <footer class="blockquote-footer"> Essence: Transparent QS customization [Optional]</footer>
              <footer class="blockquote-footer"> Essence: Add toggle to switch Fluid QS panel style [Optional]
              </footer>
              <footer class="blockquote-footer"> Essence: Add horizon light settings</footer>
              <footer class="blockquote-footer"> Essence: Adapt whole UI to match with settings</footer>
              <footer class="blockquote-footer"> GlobalActions: Redesign Power Menu</footer>
              <footer class="blockquote-footer"> Essence: Add outline QS Style</footer>
              <footer class="blockquote-footer"> Essence: Add Elixir Lock Screen Clock</footer>
              <footer class="blockquote-footer"> Implement A13 like seekbar animation</footer>
              <footer class="blockquote-footer"> Essence: Switch to new UI </footer>
              <footer class="blockquote-footer"> ven/aosp: Import More Fonts Overlay </footer>
              <footer class="blockquote-footer"> ven/aosp: Themes: Add lots of signal icons</footer>
              <footer class="blockquote-footer"> Improved stability and performance</footer>
              <footer class="blockquote-footer"> Much More,Try by yourself</footer>

            </div>
          </div>

          <div class="col-md-4">
            <img src="./assets/images/A12_cl.webp" class="card-img cl_img" alt="img">

            <a
              href="https://github.com/ProjectElixir-Devices/Changelogs/tree/tiramisu#-below-changes-are-from-android-121-">
              <p><a class="btn shadow cl-btn "> All android 12 changelogs</a></p>
            </a>

          </div>

        </div>
      </div>
    </div>

    <br>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div *ngIf="showFooter" class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
      <button type="button" class="btn active scroll-btn" data-toggle="button" aria-pressed="true"
        (click)="scrollToTop()">
        <i class="fas fa-chevron-up"></i>
      </button>
    </div>
  </div>


  <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="5532857691"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
  </ng2-adsense>

</div>

<!-- Footer Support Card -->
<div *ngIf="showFooter" class="bg-body " style="background-color: #ffebda; padding: 2rem; margin-bottom: -2rem;">
  <div class="row justify-content-center">
    <div class=" mb-3 card-radius">
      <div class="row no-gutters">

        <div class="col-md-6">
          <div class="">
            <h2 class="support_line"> Wanna Support Us ? </h2>
            <p class="patreon_highlight">Help to keep Project Elixir active and running by donating. Any
              amount is appreciated.<strong>シ </strong>
            </p>
            <h1> <a href="https://projectelixiros.com/donate">
                <a class="btn shadow footer-support-btn">Donate Now</a>
              </a></h1>

          </div>
        </div>

        <div class="col-md-6 mb-align" style="text-align: center;">
          <img src="./assets/images/donate-phone-hand.webp" class="card-img img-fluid down-carpet-img"
            style="width: 15rem;" alt="avatar">
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="showFooter">
  <app-footer></app-footer>
</div>